import { useState, useEffect, useRef, useMemo } from 'react';

interface Question { question: string; options: string[]; correct: number; }
interface Challenge { challenge: string; }

const QUESTIONS: Question[] = [
  {
    question: "Ngày Nhà giáo Việt Nam được tổ chức vào ngày nào hằng năm?",
    options: ["Ngày 20 tháng 10", "Ngày 20 tháng 11", "Ngày 22 tháng 12", "Ngày 15 tháng 11"],
    correct: 1,
  },
  {
    question: "Khi muốn thể hiện tình cảm với thầy cô, em có thể làm gì?",
    options: [
      "Mua một món quà đắt tiền ở siêu thị",
      "Nhờ bố mẹ mua hộ một bó hoa thật lớn",
      "Tự tay làm bưu thiếp hoặc một món quà nhỏ",
      "Mượn đồ dùng của bạn để đem tặng",
    ],
    correct: 2,
  },
  {
    question: "Khi tặng bưu thiếp cho thầy cô, em cần giới thiệu điều gì?",
    options: [
      "Giá tiền của vật liệu làm bưu thiếp",
      "Nêu ý nghĩa của món quà hoặc hình ảnh trên bưu thiếp",
      "Thời gian em đã bỏ ra để làm xong",
      "Tên những người bạn đã giúp em làm",
    ],
    correct: 1,
  },
  {
    question: "Việc thăm hỏi thầy cô giáo cũ của người thân (như bố, mẹ) giúp em nhận ra điều gì?",
    options: [
      "Để em được đi chơi và nhận quà",
      "Học hỏi về lòng biết ơn và truyền thống tôn sư trọng đạo",
      "Để thầy cô giáo cũ biết em học giỏi",
      "Để em không phải làm bài tập ở nhà",
    ],
    correct: 1,
  },
  {
    question: "Hành động nào dưới đây thể hiện sự biết ơn thầy cô trong cuộc sống hằng ngày?",
    options: [
      "Chỉ chào thầy cô khi có người lớn đi cùng",
      "Chăm ngoan, học giỏi và rèn luyện theo lời thầy cô dạy",
      "Chỉ tặng quà thầy cô vào những ngày lễ lớn",
      "Nói chuyện riêng khi thầy cô đang giảng bài",
    ],
    correct: 1,
  },
  {
    question: "Khi thực hiện trang trí lớp học để tri ân thầy cô, yêu cầu quan trọng nhất là gì?",
    options: [
      "Phải trang trí thật nhiều màu sắc rực rỡ",
      "Có ý thức giữ an toàn khi lao động và trang trí lớp",
      "Phải dùng những vật liệu đắt tiền nhất",
      "Phải làm một mình không cần sự giúp đỡ",
    ],
    correct: 1,
  },
  {
    question: "Chỉ cần thể hiện lòng biết ơn thầy cô vào đúng ngày 20-11 hằng năm.",
    options: ["Đúng", "Sai"],
    correct: 1,
  },
  {
    question: "Sự tiến bộ trong học tập và rèn luyện của học sinh là món quà khiến thầy cô hạnh phúc nhất.",
    options: ["Đúng", "Sai"],
    correct: 0,
  },
  {
    question: "Em không cần chào hỏi nếu đó là thầy cô giáo cũ không còn dạy lớp em nữa.",
    options: ["Đúng", "Sai"],
    correct: 1,
  },
  {
    question: "Món quà tặng thầy cô chỉ có ý nghĩa khi nó được mua với giá thật đắt tiền.",
    options: ["Đúng", "Sai"],
    correct: 1,
  },
  {
    question: "Khi mắc lỗi và bị thầy cô nhắc nhở, thái độ đúng đắn nhất của học sinh là:",
    options: [
      "Im lặng và tỏ ra giận dỗi",
      "Thành thật nhận lỗi, xin lỗi và hứa sẽ sửa đổi",
      "Đổ lỗi cho các bạn khác trong lớp",
      "Chờ đến ngày lễ mới xin lỗi để được thầy cô bỏ qua",
    ],
    correct: 1,
  },
  {
    question: "Học sinh chỉ cần lễ phép với thầy cô giáo chủ nhiệm của lớp mình.",
    options: ["Đúng", "Sai"],
    correct: 1,
  },
];

const CHALLENGES: Challenge[] = [
  { challenge: "Hãy kể 3 hoạt động thường diễn ra trong chương trình giao lưu chào mừng ngày Nhà giáo Việt Nam 20-11." },
  { challenge: "Hãy kể 2 việc đơn giản mà em có thể làm để thể hiện lòng biết ơn với các thầy cô." },
  { challenge: "Hãy hát 1 bài hát liên quan đến thầy cô." },
  { challenge: "Hãy kể nhanh 1 kỉ niệm mà em nhớ nhất về thầy cô." },
  { challenge: "Hãy kể tên 5 thầy cô giáo đã và đang dạy em." },
  { challenge: "Hãy kể tên 2 hành động em nên làm khi tình cờ gặp thầy cô giáo ở ngoài đường." },
];

type CellType = 'lucky' | 'challenge' | 'question';
type Team = 'blue' | 'red';

interface Cell { num: number; type: CellType; questionIdx: number; challengeIdx: number; }

function shuffle<T>(arr: T[]): T[] {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function generateCells(): Cell[] {
  const types: CellType[] = shuffle(['lucky', 'lucky', 'challenge', 'challenge', 'question', 'question', 'question', 'question', 'question', 'question'] as CellType[]);
  const allQIdx = Array.from({ length: QUESTIONS.length }, (_, i) => i);
  const pickedQ = shuffle(allQIdx).slice(0, 6);
  const qAssign = shuffle(pickedQ);
  const allCIdx = Array.from({ length: CHALLENGES.length }, (_, i) => i);
  const pickedC = shuffle(allCIdx).slice(0, 2);
  const cAssign = shuffle(pickedC);
  let qUsed = 0, cUsed = 0;
  return Array.from({ length: 10 }, (_, i) => ({
    num: i + 1,
    type: types[i],
    questionIdx: types[i] === 'question' ? qAssign[qUsed++] : 0,
    challengeIdx: types[i] === 'challenge' ? cAssign[cUsed++] : 0,
  }));
}

function saveAchievement(data: object) {
  try {
    const key = 'bahnar_achievements';
    const existing = JSON.parse(localStorage.getItem(key) || '[]');
    existing.unshift({ ...data, date: new Date().toLocaleDateString('vi-VN') });
    localStorage.setItem(key, JSON.stringify(existing.slice(0, 50)));
  } catch (_) { /* ignore */ }
}

const KANG_MUSIC_URL = "https://storage.readdy-site.link/project_files/d941aef1-6212-4727-9a5e-0c38b2f72f78/41df9622-081a-4483-a39a-1e36c19f1032_music_for_videos-energetic-uplifting-pop-110058.mp3?v=b41cb13ee3262ed893893126a0e31224";

function useGameAudio(playing: boolean, alertMode: boolean, muted: boolean) {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const alertIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const alertCtxRef = useRef<AudioContext | null>(null);

  // Background music — MP3 file
  useEffect(() => {
    if (!audioRef.current) {
      const audio = new Audio(KANG_MUSIC_URL);
      audio.loop = true;
      audio.volume = 0.45;
      audioRef.current = audio;
    }
    const audio = audioRef.current;
    if (playing && !alertMode && !muted) {
      audio.play().catch(() => { /* autoplay blocked */ });
    } else {
      audio.pause();
    }
  }, [playing, alertMode, muted]);

  // Alert beep
  useEffect(() => {
    if (!alertMode || muted) {
      if (alertIntervalRef.current) { clearInterval(alertIntervalRef.current); alertIntervalRef.current = null; }
      return;
    }
    const AudioCtx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    if (!alertCtxRef.current || alertCtxRef.current.state === 'closed') {
      alertCtxRef.current = new AudioCtx();
    }
    const ctx = alertCtxRef.current;
    const beep = () => {
      if (!alertCtxRef.current || alertCtxRef.current.state === 'closed') return;
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.connect(g); g.connect(ctx.destination);
      osc.type = 'square';
      osc.frequency.value = 880;
      const t = ctx.currentTime;
      g.gain.setValueAtTime(0.15, t);
      g.gain.exponentialRampToValueAtTime(0.001, t + 0.18);
      osc.start(t); osc.stop(t + 0.2);
    };
    beep();
    alertIntervalRef.current = setInterval(beep, 700);
    return () => {
      if (alertIntervalRef.current) { clearInterval(alertIntervalRef.current); alertIntervalRef.current = null; }
    };
  }, [alertMode, muted]);

  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
        audioRef.current = null;
      }
      if (alertIntervalRef.current) clearInterval(alertIntervalRef.current);
      if (alertCtxRef.current) { alertCtxRef.current.close(); alertCtxRef.current = null; }
    };
  }, []);
}

function playCorrectSound() {
  try {
    const AudioCtx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    const ctx = new AudioCtx();
    const freqs = [523, 659, 784, 1047];
    freqs.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.connect(g); g.connect(ctx.destination);
      osc.type = 'sine';
      osc.frequency.value = freq;
      const t = ctx.currentTime + i * 0.08;
      g.gain.setValueAtTime(0, t);
      g.gain.linearRampToValueAtTime(0.28, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.001, t + 0.22);
      osc.start(t); osc.stop(t + 0.25);
    });
    setTimeout(() => ctx.close(), 1200);
  } catch (_) { /* ignore */ }
}

const GAME_DURATION = 180;
const BG_IMAGE = "https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/7c39f90526686c17385d0da89249b06a.jpeg";

export default function KangGame({ onBack }: { onBack: () => void }) {
  const cells = useMemo(() => generateCells(), []);
  const [posBlue, setPosBlue] = useState(0);
  const [posRed, setPosRed] = useState(0);
  const [currentTurn, setCurrentTurn] = useState<Team>('blue');
  const [timeLeft, setTimeLeft] = useState(GAME_DURATION);
  const [phase, setPhase] = useState<'idle' | 'event' | 'done' | 'gameover'>('idle');
  const [activeCell, setActiveCell] = useState<Cell | null>(null);
  const [activeTeam, setActiveTeam] = useState<Team>('blue');
  const [selectedAnswer, setSelectedAnswer] = useState<number | null>(null);
  const [answered, setAnswered] = useState(false);
  const [isHopping, setIsHopping] = useState(false);
  const [scoreBlue, setScoreBlue] = useState(0);
  const [scoreRed, setScoreRed] = useState(0);
  const [revealedCells, setRevealedCells] = useState<Set<number>>(new Set());
  const [saved, setSaved] = useState(false);
  const [muted, setMuted] = useState(false);
  const [winner, setWinner] = useState<Team | 'draw' | null>(null);

  const isPlaying = phase === 'idle' || phase === 'event';
  const isAlert = isPlaying && timeLeft <= 5 && timeLeft > 0;

  useGameAudio(isPlaying, isAlert, muted);

  useEffect(() => {
    if (phase !== 'idle') return;
    if (timeLeft <= 0) {
      const w: Team | 'draw' = scoreBlue > scoreRed ? 'blue' : scoreRed > scoreBlue ? 'red' : 'draw';
      setWinner(w);
      setPhase('gameover');
      return;
    }
    const t = setTimeout(() => setTimeLeft(p => p - 1), 1000);
    return () => clearTimeout(t);
  }, [timeLeft, phase, scoreBlue, scoreRed]);

  const hop = () => {
    if (isHopping || phase === 'event') return;
    const curPos = currentTurn === 'blue' ? posBlue : posRed;
    if (curPos >= 10) {
      // This team finished, skip turn
      setCurrentTurn(t => t === 'blue' ? 'red' : 'blue');
      return;
    }
    setIsHopping(true);
    const jump = Math.floor(Math.random() * 3) + 1;
    const nextPos = Math.min(curPos + jump, 10);
    setTimeout(() => {
      if (currentTurn === 'blue') setPosBlue(nextPos);
      else setPosRed(nextPos);
      setIsHopping(false);
      setRevealedCells(prev => new Set([...prev, nextPos]));
      if (nextPos === 10) {
        // This team reached the end
        const otherPos = currentTurn === 'blue' ? posRed : posBlue;
        if (otherPos >= 10) {
          // Both done
          const w: Team | 'draw' = scoreBlue > scoreRed ? 'blue' : scoreRed > scoreBlue ? 'red' : 'draw';
          setWinner(w);
          setPhase('done');
        } else {
          // Current team won by reaching 10
          setWinner(currentTurn);
          setPhase('done');
        }
        return;
      }
      const cell = cells[nextPos - 1];
      setActiveCell(cell);
      setActiveTeam(currentTurn);
      setPhase('event');
    }, 500);
  };

  const handleLucky = () => {
    setPhase('idle');
    setActiveCell(null);
    setCurrentTurn(t => t === 'blue' ? 'red' : 'blue');
  };

  const handleChallenge = () => {
    if (activeTeam === 'blue') setScoreBlue(s => s + 5);
    else setScoreRed(s => s + 5);
    setPhase('idle');
    setActiveCell(null);
    setCurrentTurn(t => t === 'blue' ? 'red' : 'blue');
  };

  const handleAnswer = (idx: number) => {
    if (answered || !activeCell) return;
    setSelectedAnswer(idx);
    setAnswered(true);
    const q = QUESTIONS[activeCell.questionIdx];
    const correct = idx === q.correct;
    if (correct) {
      if (!muted) playCorrectSound();
      if (activeTeam === 'blue') setScoreBlue(s => s + 10);
      else setScoreRed(s => s + 10);
    }
    setTimeout(() => {
      setAnswered(false);
      setSelectedAnswer(null);
      setActiveCell(null);
      setPhase('idle');
      setCurrentTurn(t => t === 'blue' ? 'red' : 'blue');
    }, 1500);
  };

  const handleSave = () => {
    saveAchievement({
      game: 'K\'ăng (Nhảy lò cò)',
      winner: winner === 'draw' ? 'Hòa' : winner === 'blue' ? 'Đội Xanh' : 'Đội Đỏ',
      scoreBlue,
      scoreRed,
    });
    setSaved(true);
  };

  const handleRestart = () => {
    setPosBlue(0);
    setPosRed(0);
    setCurrentTurn('blue');
    setTimeLeft(GAME_DURATION);
    setPhase('idle');
    setActiveCell(null);
    setActiveTeam('blue');
    setSelectedAnswer(null);
    setAnswered(false);
    setIsHopping(false);
    setScoreBlue(0);
    setScoreRed(0);
    setRevealedCells(new Set());
    setSaved(false);
    setWinner(null);
  };

  const cellColors: Record<CellType, { bg: string; border: string; icon: string; label: string }> = {
    lucky: { bg: 'bg-green-100', border: 'border-green-400', icon: '🍀', label: 'May mắn' },
    challenge: { bg: 'bg-amber-100', border: 'border-amber-400', icon: '⚡', label: 'Thử thách' },
    question: { bg: 'bg-sky-100', border: 'border-sky-400', icon: '❓', label: 'Câu hỏi' },
  };

  const mins = Math.floor(timeLeft / 60);
  const secs = timeLeft % 60;

  const endPhase = phase === 'done' || phase === 'gameover';

  if (endPhase) {
    const wonTeam = winner;
    return (
      <div className="relative min-h-screen flex flex-col items-center justify-center px-6 py-12 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img src={BG_IMAGE} alt="bg" className="w-full h-full object-cover object-top" />
          <div className={`absolute inset-0 ${phase === 'gameover' ? 'bg-amber-900/55' : 'bg-yellow-900/50'} backdrop-blur-sm`}></div>
        </div>
        <div className="relative z-10 flex flex-col items-center w-full max-w-md">
          <div className="text-7xl mb-4">{wonTeam === 'draw' ? '🤝' : '🏆'}</div>
          <h2 className="text-3xl font-extrabold text-white mb-2 drop-shadow">
            {wonTeam === 'draw' ? 'Hòa nhau!' : `Đội ${wonTeam === 'blue' ? '🔵 Xanh' : '🔴 Đỏ'} thắng!`}
          </h2>
          <p className="text-white/80 mb-8 text-center">
            {phase === 'gameover' ? 'Hết giờ — tổng kết điểm!' : 'Đội đã nhảy đến ô đích đầu tiên!'}
          </p>
          <div className="flex gap-4 mb-8 w-full">
            <div className="flex-1 bg-sky-500/30 backdrop-blur-md rounded-2xl px-6 py-4 text-center border border-sky-300/50">
              <p className="text-sm text-sky-200 mb-1">🔵 Đội Xanh</p>
              <p className="text-3xl font-extrabold text-white">{scoreBlue}</p>

            </div>
            <div className="flex-1 bg-red-500/30 backdrop-blur-md rounded-2xl px-6 py-4 text-center border border-red-300/50">
              <p className="text-sm text-red-200 mb-1">🔴 Đội Đỏ</p>
              <p className="text-3xl font-extrabold text-white">{scoreRed}</p>

            </div>
          </div>
          <div className="flex gap-4 flex-wrap justify-center">
            {!saved ? (
              <button onClick={handleSave} className="px-7 py-3 bg-gradient-to-r from-green-500 to-emerald-400 text-white font-bold rounded-2xl cursor-pointer whitespace-nowrap flex items-center gap-2">
                <i className="ri-trophy-fill"></i> Lưu thành tích
              </button>
            ) : (
              <div className="px-7 py-3 bg-green-100 text-green-700 font-bold rounded-2xl flex items-center gap-2">
                <i className="ri-check-fill"></i> Đã lưu!
              </div>
            )}
            <button onClick={handleRestart} className="px-7 py-3 bg-gradient-to-r from-sky-500 to-sky-400 text-white font-bold rounded-2xl cursor-pointer whitespace-nowrap flex items-center gap-2">
              <i className="ri-restart-line"></i> Chơi lại
            </button>
            <button onClick={onBack} className="px-7 py-3 bg-gradient-to-r from-primary-orange to-primary-yellow text-white font-bold rounded-2xl cursor-pointer whitespace-nowrap flex items-center gap-2">
              <i className="ri-home-4-line"></i> Trang chủ
            </button>
          </div>
        </div>
      </div>
    );
  }

  const curPos = currentTurn === 'blue' ? posBlue : posRed;

  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img src={BG_IMAGE} alt="bg" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-white/60 backdrop-blur-[2px]"></div>
      </div>

      {/* Alert flash */}
      {isAlert && (
        <div className="absolute inset-0 z-10 pointer-events-none animate-pulse bg-red-500/20"></div>
      )}

      <div className="relative z-20 max-w-2xl mx-auto px-6 pt-6 pb-10">

        {/* Top bar */}
        <div className="flex items-center justify-between mb-4">
          {/* Blue team score */}
          <div className={`rounded-2xl px-4 py-2 flex items-center gap-2 border-2 transition-all ${currentTurn === 'blue' ? 'bg-sky-100 border-sky-500 scale-105' : 'bg-white/80 border-sky-200'}`}>
            <span className="text-lg">🔵</span>
            <div>
              <p className="text-xs text-sky-500 font-bold">Đội Xanh</p>
              <p className="text-lg font-extrabold text-sky-700">{scoreBlue} đ</p>
            </div>
          </div>

          {/* Timer + mute */}
          <div className={`relative rounded-2xl px-5 py-2 text-center ${isAlert ? 'ring-4 ring-red-500 animate-pulse bg-red-50' : 'bg-white/80'}`}>
            <p className={`font-extrabold text-2xl font-mono ${timeLeft <= 5 ? 'text-red-600' : timeLeft <= 30 ? 'text-amber-500' : 'text-primary-brown-dark'}`}>
              {mins}:{secs.toString().padStart(2, '0')}
            </p>
            {isAlert && <p className="text-xs text-red-600 font-bold">⚠️ Hết giờ!</p>}
            {/* Mute button */}
            <button
              onClick={() => setMuted(m => !m)}
              className="absolute -top-2 -right-2 w-7 h-7 flex items-center justify-center bg-primary-orange rounded-full text-white hover:opacity-80 transition-all cursor-pointer"
              title={muted ? 'Bật tiếng' : 'Tắt tiếng'}
            >
              <i className={`${muted ? 'ri-volume-mute-fill' : 'ri-volume-up-fill'} text-xs`}></i>
            </button>
          </div>

          {/* Red team score */}
          <div className={`rounded-2xl px-4 py-2 flex items-center gap-2 border-2 transition-all ${currentTurn === 'red' ? 'bg-red-100 border-red-500 scale-105' : 'bg-white/80 border-red-200'}`}>
            <div className="text-right">
              <p className="text-xs text-red-400 font-bold">Đội Đỏ</p>
              <p className="text-lg font-extrabold text-red-600">{scoreRed} đ</p>
            </div>
            <span className="text-lg">🔴</span>
          </div>
        </div>

        {/* Turn indicator */}
        <div className={`text-center mb-4 py-2 px-4 rounded-2xl font-bold text-sm ${currentTurn === 'blue' ? 'bg-sky-500 text-white' : 'bg-red-500 text-white'}`}>
          {currentTurn === 'blue' ? '🔵 Lượt Đội Xanh' : '🔴 Lượt Đội Đỏ'}
          {isHopping && ' — đang nhảy...'}
        </div>

        {/* Game board */}
        <div className="grid grid-cols-5 gap-2 mb-5">
          {[...cells.slice(0, 5), ...cells.slice(5).reverse()].map(cell => {
            const isBlueHere = posBlue === cell.num;
            const isRedHere = posRed === cell.num;
            const isRevealed = revealedCells.has(cell.num);
            const colors = cellColors[cell.type];

            return (
              <div key={cell.num}
                className={`relative aspect-square rounded-2xl border-2 flex flex-col items-center justify-center transition-all duration-300 ${
                  isRevealed
                    ? `${colors.bg} ${colors.border}`
                    : 'bg-white/80 border-primary-brown-light/30'
                } ${(isBlueHere || isRedHere) ? 'scale-110' : ''}`}
              >
                {/* Cell number */}
                <span className="text-xs font-bold text-primary-brown-light mb-0.5">{cell.num}</span>

                {/* Revealed: show type icon. Hidden: show ? */}
                <span className="text-xl">
                  {isRevealed ? colors.icon : '?'}
                </span>

                {/* Team tokens */}
                <div className="absolute -top-2 left-1/2 -translate-x-1/2 flex gap-0.5">
                  {isBlueHere && <span className="text-sm animate-bounce">🔵</span>}
                  {isRedHere && <span className="text-sm animate-bounce">🔴</span>}
                </div>
              </div>
            );
          })}
        </div>

        {/* Position tracker */}
        <div className="flex items-center gap-3 mb-4 text-xs">
          <div className="flex-1 bg-sky-50/80 rounded-xl px-3 py-2 text-center border border-sky-200">
            <span className="text-sky-600 font-bold">🔵 Xanh — Ô {posBlue}/10</span>
          </div>
          <div className="flex-1 bg-red-50/80 rounded-xl px-3 py-2 text-center border border-red-200">
            <span className="text-red-600 font-bold">🔴 Đỏ — Ô {posRed}/10</span>
          </div>
        </div>

        {/* Hop button */}
        <div className="flex flex-col items-center gap-3">
          <button
            onClick={hop}
            disabled={isHopping || phase === 'event' || curPos >= 10}
            className={`px-10 py-4 font-extrabold text-lg rounded-2xl transition-all cursor-pointer whitespace-nowrap disabled:opacity-40 ${
              currentTurn === 'blue'
                ? 'bg-gradient-to-r from-sky-500 to-sky-400 text-white'
                : 'bg-gradient-to-r from-red-500 to-red-400 text-white'
            }`}
          >
            {isHopping
              ? '🦘 Đang nhảy...'
              : curPos >= 10
              ? '✅ Đã đến đích!'
              : currentTurn === 'blue' ? '🔵 Đội Xanh nhảy!' : '🔴 Đội Đỏ nhảy!'}
          </button>
          {curPos >= 10 && (
            <p className="text-sm text-primary-brown-light">Đội {currentTurn === 'blue' ? 'Xanh đang' : 'Đỏ đang'} chờ đội kia hoàn thành...</p>
          )}
        </div>

        {/* Event overlay */}
        {phase === 'event' && activeCell && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/50 backdrop-blur-sm">
            <div className="bg-white rounded-3xl max-w-md w-full p-8">
              {/* Team indicator */}
              <div className={`flex items-center gap-2 mb-4 px-3 py-1.5 rounded-full w-fit mx-auto ${activeTeam === 'blue' ? 'bg-sky-100 text-sky-600' : 'bg-red-100 text-red-600'}`}>
                <span>{activeTeam === 'blue' ? '🔵' : '🔴'}</span>
                <span className="text-sm font-bold">Đội {activeTeam === 'blue' ? 'Xanh' : 'Đỏ'} — Ô {activeTeam === 'blue' ? posBlue : posRed}</span>
              </div>

              {activeCell.type === 'lucky' && (
                <div className="text-center">
                  <div className="text-6xl mb-4">🍀</div>
                  <h3 className="text-2xl font-extrabold text-green-600 mb-2">Ô May Mắn!</h3>
                  <p className="text-primary-brown-light text-sm mb-5">Chúc mừng! Bạn nhận được phần thưởng may mắn!</p>
                  <button onClick={handleLucky} className="w-full px-8 py-3.5 bg-gradient-to-r from-green-500 to-green-400 text-white font-bold rounded-2xl cursor-pointer whitespace-nowrap">
                    Nhảy tiếp! 🎉
                  </button>
                </div>
              )}

              {activeCell.type === 'challenge' && (
                <div className="text-center">
                  <div className="text-6xl mb-4">⚡</div>
                  <h3 className="text-2xl font-extrabold text-amber-600 mb-3">Ô Thử Thách!</h3>
                  <div className="bg-amber-50 rounded-2xl p-4 mb-4 text-left">
                    <p className="text-primary-brown font-semibold">{CHALLENGES[activeCell.challengeIdx].challenge}</p>
                  </div>
                  <p className="text-sm text-primary-brown-light mb-4">Hoàn thành thử thách để nhận 5 điểm!</p>
                  <button onClick={handleChallenge} className="w-full px-8 py-3.5 bg-gradient-to-r from-amber-500 to-amber-400 text-white font-bold rounded-2xl cursor-pointer whitespace-nowrap">
                    Đã hoàn thành! +5 điểm
                  </button>
                </div>
              )}

              {activeCell.type === 'question' && (() => {
                const q = QUESTIONS[activeCell.questionIdx];
                return (
                  <div>
                    <div className="text-center mb-4">
                      <div className="text-5xl mb-2">❓</div>
                      <h3 className="text-xl font-extrabold text-sky-600">Ô Câu Hỏi!</h3>
                    </div>
                    <p className="text-lg font-bold text-primary-brown-dark mb-4 leading-snug">{q.question}</p>
                    <div className="space-y-2">
                      {q.options.map((opt, idx) => {
                        let style = 'border-2 border-primary-brown-light/20 bg-primary-cream text-primary-brown hover:border-sky-400';
                        if (answered) {
                          if (idx === q.correct) style = 'border-2 border-green-400 bg-green-50 text-green-700 font-bold';
                          else if (idx === selectedAnswer) style = 'border-2 border-red-400 bg-red-50 text-red-500';
                          else style = 'border-2 border-transparent bg-white/50 text-primary-brown-light';
                        }
                        return (
                          <button key={idx} onClick={() => handleAnswer(idx)} disabled={answered}
                            className={`w-full text-left px-4 py-3 rounded-xl text-sm transition-all cursor-pointer ${style}`}>
                            <span className="font-bold mr-2">{String.fromCharCode(65 + idx)}.</span>{opt}
                          </button>
                        );
                      })}
                    </div>
                    {answered && (
                      <div className={`mt-3 text-center py-2 rounded-xl font-bold text-sm ${selectedAnswer === q.correct ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-600'}`}>
                        {selectedAnswer === q.correct ? '✅ Đúng! +10 điểm' : '❌ Sai rồi! Mất lượt'}
                      </div>
                    )}
                  </div>
                );
              })()}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
